import { baseApi } from "@store/apis";
import { store } from "@store/index";
import i18next from "i18next";


export function changeLanguage(langKey: "ar" | "en") {
  i18next
    .changeLanguage(langKey)
    .then(() => {
      // Save language to normal localStorage so i18n can read it
      // localStorage.setItem("i18nextLng", langKey);
      changeDocumentLanguageAttributes();
    });
  store.dispatch(baseApi.util.resetApiState());
}
export function switchLanguage() {
  const langKey = i18next.language === "en" ? "ar" : "en";
  changeLanguage(langKey);
}
export function changeDocumentLanguageAttributes() {
  document.documentElement.dir = i18next.dir();
  document.documentElement.lang = i18next.language;
}

